import type { Abogado } from '../types'
import { fechaRel } from '../utils/fechas'

/** Alta inicial del personal. Editable desde Configuración → Abogados y personal. */
export const ABOGADOS_INICIALES: Abogado[] = [
  {
    id: 'ab-01',
    nombre: 'Lic. Mariana Cervantes Rojo',
    cedula: '8451237',
    sucursalId: 'ver',
    especialidades: ['Penal', 'Amparo'],
    correo: 'm.cervantes@limaamaro.mx',
    telefono: '229 118 4420',
    rol: 'Abogado',
    foto: 'https://cdn.magicpatterns.com/patterns/generated-images/dbfa3d13-d942-4840-bd77-988197d5c0cb.jpg',
    fechaIngreso: fechaRel(-2280),
    activo: true,
  },
  {
    id: 'ab-02',
    nombre: 'Lic. Ricardo Menchaca Villalobos',
    cedula: '7712064',
    sucursalId: 'ver',
    especialidades: ['Civil', 'Mercantil'],
    correo: 'r.menchaca@limaamaro.mx',
    telefono: '229 204 7781',
    rol: 'Abogado',
    fechaIngreso: fechaRel(-3140),
    activo: true,
  },
  {
    id: 'ab-03',
    nombre: 'Lic. Ana Paula Zúñiga Bernal',
    cedula: '9032518',
    sucursalId: 'cmx',
    especialidades: ['Administrativo', 'Amparo'],
    correo: 'a.zuniga@limaamaro.mx',
    telefono: '55 4412 9033',
    rol: 'Abogado',
    fechaIngreso: fechaRel(-1490),
    activo: true,
  },
  {
    id: 'ab-04',
    nombre: 'Lic. Jorge Emilio Sandoval Paz',
    cedula: '6698431',
    sucursalId: 'cmx',
    especialidades: ['Mercantil', 'Civil'],
    correo: 'j.sandoval@limaamaro.mx',
    telefono: '55 3390 1187',
    rol: 'Administrador',
    foto: 'https://cdn.magicpatterns.com/patterns/generated-images/35e2e380-8334-41f8-85f3-1032bb6530e1.jpg',
    fechaIngreso: fechaRel(-4620),
    activo: true,
  },
  {
    id: 'ab-05',
    nombre: 'Lic. Fernanda Oceguera Lima',
    cedula: '9218740',
    sucursalId: 'gdl',
    especialidades: ['Laboral', 'Familiar'],
    correo: 'f.oceguera@limaamaro.mx',
    telefono: '33 1450 6622',
    rol: 'Abogado',
    foto: 'https://cdn.magicpatterns.com/patterns/generated-images/6cb25261-bbe1-41bb-87fc-68368906aa07.jpg',
    fechaIngreso: fechaRel(-2010),
    activo: true,
  },
  {
    id: 'ab-06',
    nombre: 'Lic. Óscar Iván Barajas Núñez',
    cedula: '8107623',
    sucursalId: 'gdl',
    especialidades: ['Penal'],
    correo: 'o.barajas@limaamaro.mx',
    telefono: '33 2288 4019',
    rol: 'Abogado',
    foto: 'https://cdn.magicpatterns.com/patterns/generated-images/4b5294f0-1d8d-4c85-a05d-8c9c81019d45.jpg',
    fechaIngreso: fechaRel(-680),
    activo: true,
  },
  {
    id: 'ab-07',
    nombre: 'Lic. Regina Treviño Alanís',
    cedula: '9540112',
    sucursalId: 'mty',
    especialidades: ['Civil', 'Familiar'],
    correo: 'r.trevino@limaamaro.mx',
    telefono: '81 1902 7745',
    rol: 'Abogado',
    foto: 'https://cdn.magicpatterns.com/patterns/generated-images/187c503c-790f-47f5-a8cc-1905f37c5305.jpg',
    fechaIngreso: fechaRel(-1180),
    activo: true,
  },
  {
    id: 'ab-08',
    nombre: 'Lic. Humberto Salas Quintanilla',
    cedula: '7304988',
    sucursalId: 'mty',
    especialidades: ['Mercantil', 'Administrativo'],
    correo: 'h.salas@limaamaro.mx',
    telefono: '81 2044 3318',
    rol: 'Abogado',
    fechaIngreso: fechaRel(-3980),
    activo: true,
  },
  {
    id: 'ab-09',
    nombre: 'Lic. Dalia Fuentes Escobar',
    cedula: '9877203',
    sucursalId: 'ver',
    especialidades: ['Laboral'],
    correo: 'd.fuentes@limaamaro.mx',
    telefono: '229 331 5502',
    rol: 'Abogado',
    fechaIngreso: fechaRel(-430),
    activo: true,
  },
  {
    id: 'ab-10',
    nombre: 'Sra. Leticia Ordaz Peña',
    cedula: 'No aplica',
    sucursalId: 'ver',
    especialidades: [],
    correo: 'l.ordaz@limaamaro.mx',
    telefono: '229 118 4408',
    rol: 'Recepción/Archivo',
    fechaIngreso: fechaRel(-2650),
    activo: true,
  },
  {
    id: 'ab-11',
    nombre: 'Sr. Braulio Camacho Ruiz',
    cedula: 'No aplica',
    sucursalId: 'cmx',
    especialidades: [],
    correo: 'b.camacho@limaamaro.mx',
    telefono: '55 4412 9011',
    rol: 'Recepción/Archivo',
    fechaIngreso: fechaRel(-1320),
    activo: true,
  },
  {
    id: 'ab-12',
    nombre: 'Lic. Tomás Iriarte Beltrán',
    cedula: '7014582',
    sucursalId: 'gdl',
    especialidades: ['Civil'],
    correo: 't.iriarte@limaamaro.mx',
    telefono: '33 1450 6690',
    rol: 'Abogado',
    fechaIngreso: fechaRel(-5100),
    activo: false,
  },
]

export const PERSONAL_ARCHIVO = [
  'Sra. Leticia Ordaz (Archivo VER)',
  'Sr. Braulio Camacho (Archivo CMX)',
  'Srita. Miriam Aceves (Recepción GDL)',
  'Sr. Genaro Puente (Archivo MTY)',
]

/**
 * Registro vivo del personal: el contexto lo sincroniza en cada alta o edición para que
 * las vistas de solo lectura resuelvan nombres y cédulas actualizados.
 */
let registro: Abogado[] = ABOGADOS_INICIALES

export function sincronizarAbogados(lista: Abogado[]): void {
  registro = lista
}

export function abogadoPorId(id: string): Abogado | undefined {
  return registro.find((a) => a.id === id)
}

export function inicialesDe(nombre: string): string {
  const limpio = nombre.replace(/^(Lic\.|Sra\.|Sr\.|Srita\.|Mtro\.|Dr\.)\s*/, '').split(' ')
  return `${limpio[0]?.[0] ?? ''}${limpio[1]?.[0] ?? ''}`.toUpperCase()
}
